module.exports = __webpack_public_path__ + "static/media/background.5d368457.jpg";